import { render } from "./GradeBook.vue?vue&type=template&id=1ea88904&scoped=true"
import script from "./GradeBook.vue?vue&type=script&lang=js"
export * from "./GradeBook.vue?vue&type=script&lang=js"

import "./GradeBook.vue?vue&type=style&index=0&id=1ea88904&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea88904"]])

export default __exports__